<!--
 * @Date: 2023-08-25 09:19:51

-->
<template>
<bk-page
	:class="{
		'appointmentPage':true,
		['appointmentPage-kisDZFlag']:kisDZFlag,
		['appointmentPage-oblissDZFlag']:oblissDZFlag,
		'appointmentPage-komoDZFlag':komoDZFlag,
	}"
>
	<bk-view :class="['a-header', showLoginGuid ? 'a-header__empty' : '']">
		<bk-view v-if="showLoginGuid">
			<bk-view class="empty-view">
				<bk-image :src="emptyUrl"></bk-image>
				<bk-lang code="appointment_login_tips"></bk-lang>
				<bk-button  langCode="appointment_login" @click="userInfoItemClick"></bk-button>
			</bk-view>
		</bk-view>
		<bk-view class="a-tabs" v-else>
			<div class="view-list">
				<bk-view :class="['view-item', status === item.status ? 'active' : '']" v-for="item in aTabs" :key="item.code" @click="changeTab(item)">
					<bk-lang :code="item.langCode"></bk-lang>
				</bk-view>
			</div>
		</bk-view>
	</bk-view>
	
	<bk-view class="a-body" :key="uuId" v-if="dataList?.length || userInfo?.id">
		<bk-scroll-list
			ref="bkScrollList"
			:key="status"
			:async-load-data="getDataList" >	
			
			<template v-slot="{ dataList }" v-if="['0','waitlist'].includes(status)">
				<upcoming-item
					v-for="item in dataList"
					:item="item"
					:key="item.id"
					@click="toDetailPage(item)" />
			</template>
			
			<template v-slot="{ dataList }" v-else>
				<comm-res-item 
					v-for="item in dataList"
					:item="item"
					:key="item.id"
					@book="handleBook(item)"
					@click="toDetailPage(item)" />
			</template>
		</bk-scroll-list>
		
	</bk-view>

	<transition name="rightFadeIn">
		<component 
			v-if="componentName"
			mode="component"
			:resShopInfo="resShopInfo"
			:bizScene="bizScene"
			:id="resId" 
			:status="status" 
			:is="componentName" 
			@close="setCurName(null)"
			@reload="reloadData"
		>
		</component>
	</transition>
</bk-page>
</template>

<script>
	import UpcomingItem from './subViews/upcomingItem/upcomingItem.vue';
	import CommResItem from './subViews/commResItem/commResItem.vue';
	import AppointmentDetail from './subPages/appointmentDetail/appointmentDetail.vue';
	import Reserve from '@/pages/reserve/reserve';
	import { aTabs } from './dataSource';	
	import { reserveReq } from '@r';
	export default {
		name: 'appointments',
		components: { UpcomingItem, CommResItem, AppointmentDetail, Reserve },
		data (){
			this.aTabs = aTabs;
			return {
				kisDZFlag: window.kisDZFlag,
				oblissDZFlag: window.oblissDZFlag,
				komoDZFlag:window.komoDZFlag,
				status: 'waitlist',
				showDetailFlag: false,
				resId:'',
				dataList: [{}],
				pageNum: 1,
				componentName: '',
				resShopInfo: {},
				userInfo: this.$bk_getUserInfo(),
				uuId:this.$bk_getGUID(),
				showLoginGuid:false,
			};
		},

		computed: {
			emptyUrl (){
				let res = 'Def_Appointment_Empty.png' 
				
				if(window.oblissDZFlag ){
					res = 'Def_Appointment_Empty_healthy.png'
				}	

				if(window.komoDZFlag){
					res = 'Def_Appointment_Empty_Komo.png'
				}	
				return this.$bk_getImageUrl(res);
			},
			bizScene(){
				return this.status==='waitlist' ? 'waiting': 'reserve'
			}
		},
		watch: { 
			dataList(){
				this.setShowLoginGuid();
			}
		},
		methods: {
			userInfoItemClick () {
				bkLog.log('userInfoItemClick:::', this.$bk_copy(this.userInfo), window.viewInfo);
				let that = this;
				if (!this.userInfo || !this.userInfo.id || this.userInfo.silent||window.viewInfo?.silent) {
					this.userInfo={};//解决登录退出静默登录，点击不跳转登录
					window.showLogin({
						callback: function (userInfo) {
							that.userInfo = userInfo;
							that.initData();
						}
					});
				}
			},
			initData () {
				this.userInfo = this.$bk_getUserInfo();
				this.setShowLoginGuid()
			},

			changeTab (item) {
				console.log(item,'item item item=>')
				this.status = item.status;
				if( item.status === '0' ) {
					this.dataList = [{}];
				}
				this.pageNum = 1;
			},

			async getDataList (params) {
				const { status } = this;
				let data = {
					status,
					...params,
				};

				if(window.kisDZFlag || window.oblissDZFlag || window.komoDZFlag){
					data.whiteCustId = this.$bk_getShopDetailInfo()?.custId;
				}

				let res;

				if(status==='waitlist'){
					data.status = 0;
					res = await reserveReq.requestFindWaitlistList(this, data).catch(() => {});
				}else {
					res = await reserveReq.requestGetMemberReserveData(this, data).catch(() => {});
				}

				if(res?.list){
					res.list?.forEach((vItem)=>{
						vItem.bizScene = this.bizScene;
					})
				}
			
				this.dataList = res?.list;

				return { data: res?.list, total:res?.page?.total };
			},

			toDetailPage (item) {
				this.resId = item.id;
				this.setCurName('AppointmentDetail');
			},

			handleBook (item) {
				this.resShopInfo = { id: item.compId };
				this.setCurName('Reserve');
			},

			setCurName (name) {
				this.componentName = name;
			},
			reloadData (){
				this.pageNum = 1;

				if (this.$refs.bkScrollList) {
					this.$refs.bkScrollList.reloadData();
				}
			},
			// 展示登录引导内容: 静默登录(没有真正登录)并且没有预约记录
			setShowLoginGuid () {
				const { dataList, status } = this;
				const userInfo = this.$bk_getUserInfo();
				
				this.showLoginGuid = window.viewInfo?.silent ? (!dataList?.length) : !userInfo?.id;
			},
		},
		activated () {
			this.uuId = this.$bk_getGUID();
			this.dataList = [{}];
			this.reloadData();
		},
		
	};
</script>

<style lang="less" scoped>
	@import './appointments.less';
</style>
